// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@store/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

export type LinkTypeOption = DataOption;
export interface LinkTypeOptionMapper {
    destination: LinkTypeOption;
    file: LinkTypeOption;
}
export type LinkTypeOptions = DataOptions<LinkTypeOption> & LinkTypeOptionMapper;
export type LinkType = LiteralUnion<keyof LinkTypeOptionMapper>;

export const linkTypeOptions: LinkTypeOptions = {
    destination: { id: "destination", displayName: "Page/Category/Url", isDefault: true },
    file: { id: "file", displayName: "File" },
};

export type LinkTypeFieldValue = LinkType | undefined;
export interface LinkTypeFieldOptions {
    isChildDefinition?: boolean;
}

export const getLinkTypeFieldData = (value: LinkTypeFieldValue, options?: LinkTypeFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(linkTypeOptions, value);
};

export const getLinkTypeFieldDefinition = (name: string, options?: LinkTypeFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(linkTypeOptions),
        name,
        displayName: "Link Type",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getLinkTypeField = (name: string, options?: LinkTypeFieldOptions) => {
    const parse = (value: LinkTypeFieldValue) => getLinkTypeFieldData(value, options);

    return {
        definition: getLinkTypeFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getLinkTypeField;
